import { useQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import {
  Text,
  GreyGrey30,
  GreyGrey80,
  Primary14SemiBold,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Flex
} from '@sequencehq/core-components'
import { EmptyContent } from 'modules/Products/Product/components/EmptyContent'
import { ProductPriceVariant } from 'modules/Products/Product/components/ProductPriceVariant'
import { ProductPriceDrawer } from 'modules/Products/drawers/ProductPrice/ProductPriceDrawer'
import { priceRowFormatter } from 'modules/Products/formatters'
import { PriceTableRow } from 'modules/Products/types'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import invariant from 'tiny-invariant'

export const ProductPriceVariants = () => {
  const { productId } = useParams<{ productId: string }>()
  invariant(productId, 'productId is required')

  const [selectedPriceRow, setSelectedPriceRow] =
    useState<PriceTableRow | null>(null)

  const productMetadataQuery = useQuery(
    dashboardv20240509Client.getProductMetadata,
    {
      id: productId
    }
  )

  const pricesTableData = useMemo(
    () => productMetadataQuery.data?.priceVariants.map(priceRowFormatter) ?? [],
    [productMetadataQuery.data?.priceVariants]
  )

  return (
    <Flex flexDirection="column">
      <Text {...Primary14SemiBold} color={GreyGrey80}>
        Price variants
      </Text>

      {productMetadataQuery.isPending ? (
        <Flex mt={4}>
          <Skeleton width="100%" height="256px" />
        </Flex>
      ) : (
        <TableContainer
          borderRadius="lg"
          overflow="hidden"
          border={`1px solid ${GreyGrey30}`}
          mt={4}
          width="100%"
        >
          <Table variant="v2" width="100%">
            <Thead>
              <Tr>
                <Th width="25%">Price</Th>
                <Th width="25%">Customer</Th>
                <Th>Currency</Th>
                <Th>Frequency</Th>
                <Th>Pricing model</Th>
                <Th width={100}>Status</Th>
                <Th>Created</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pricesTableData.length > 0 ? (
                pricesTableData.map(priceRow => (
                  <ProductPriceVariant
                    key={priceRow.id}
                    priceRow={priceRow}
                    onSelect={() => setSelectedPriceRow(priceRow)}
                  />
                ))
              ) : (
                <Tr
                  sx={{
                    cursor: 'auto!important',
                    _hover: {
                      bgColor: 'inherit!important'
                    }
                  }}
                >
                  <Td colSpan={7}>
                    <EmptyContent priceType="VARIANT" />
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      )}

      {selectedPriceRow && (
        <ProductPriceDrawer
          priceId={selectedPriceRow.id}
          onClose={() => setSelectedPriceRow(null)}
        />
      )}
    </Flex>
  )
}
